import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import { useCallback, useRef, useState, Fragment } from 'react';
export function useScrollWithShadow(useTailwindPrefix) {
    const [scrollTop, setScrollTop] = useState(0);
    const [scrollHeight, setScrollHeight] = useState(0);
    const [clientHeight, setClientHeight] = useState(0);
    const resizingDelayTimer = useRef(null);
    const ref = useCallback((node) => {
        if (!node)
            return;
        const resizeObserver = new ResizeObserver(() => {
            if (resizingDelayTimer.current) {
                clearTimeout(resizingDelayTimer.current);
            }
            resizingDelayTimer.current = setTimeout(() => {
                reset(node);
            }, 0);
        });
        resizeObserver.observe(node);
    }, []);
    const onScrollHandler = (event) => {
        const target = event.target;
        setScrollTop(target.scrollTop);
        setScrollHeight(target.scrollHeight);
        setClientHeight(target.clientHeight);
    };
    function reset(target) {
        setScrollTop(target.scrollTop);
        setScrollHeight(target.scrollHeight);
        setClientHeight(target.clientHeight);
    }
    const topShadow = (_jsx("div", { className: classNames({
            'absolute top-0 left-0 right-0 h-[10px] bg-none': !useTailwindPrefix,
            'tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-h-[10px] tw-bg-none': useTailwindPrefix,
        }), style: {
            background: 'linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.1) 100%)',
        } }));
    const bottomShadow = (_jsx("div", { className: classNames({
            'absolute bottom-0 left-0 right-0 h-[10px] bg-none': !useTailwindPrefix,
            'tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-h-[10px] tw-bg-none': useTailwindPrefix,
        }), style: {
            background: 'linear-gradient(0deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0) 100%)',
        } }));
    function drawShadows() {
        if (Math.abs(scrollHeight - clientHeight) < 1) {
            return null;
        }
        const isBottom = Math.abs(clientHeight - (scrollHeight - scrollTop)) < 1;
        const isTop = scrollTop === 0;
        const isBetween = scrollTop > 0 &&
            clientHeight < scrollHeight - scrollTop &&
            Math.abs(clientHeight - (scrollHeight - scrollTop)) > 1;
        let result = [];
        if (isTop) {
            result.push(bottomShadow);
        }
        else if (isBetween) {
            result.push(bottomShadow);
            result.push(topShadow);
        }
        else if (isBottom) {
            result.push(topShadow);
        }
        if (result.length > 0) {
            return (_jsx(_Fragment, { children: result.map((item, index) => (_jsx(Fragment, { children: item }, index))) }));
        }
        return null;
    }
    return {
        containerRef: ref,
        drawShadows,
        onScrollHandler,
        parentStyle: { position: 'relative' },
    };
}
